
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/ee-footer.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-ee-footer-demo-ee-footer","docs-power-design-ee-footer-demo-dark"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/ee-footer.md?type=demo')
};